export class UIEventEmitter {
    subscribe(name, callback) {
        if (this.events[name] == undefined) {
            this.events[name] = [];
        }
        this.events[name].push(callback);
        return {
            unsubscribe: ()=>this.unsubscribe(name, callback)
        };
    }
    subscribeOnce(name, callback) {
        const listener = this.subscribe(name, (...args)=>{
            listener.unsubscribe();
            callback.apply(null, [
                ...args
            ]);
        });
    }
    listenerCount(name) {
        if (this.events[name] == undefined) {
            return 0;
        }
        return this.events[name].length;
    }
    unsubscribe(name, callback) {
        if (this.events[name] == undefined) {
            return;
        }
        this.events[name] = this.events[name].filter((event)=>event !== callback);
    }
    emit(name, ...args) {
        if (this.events[name] == undefined) {
            return;
        }
        this.events[name].forEach((eventCallback)=>eventCallback.apply(null, [
                ...args
            ]));
    }
    constructor(events = {}){
        this.events = events;
    }
}
